import { Observable } from 'rxjs';

import { MatchType } from 'app/constants/match-type';
import { LocationMatchType, MccMatchEnum } from 'app/enum';
import { PatternData, makePatternData } from 'app/model';
import { MlSampleMetadata } from 'app/model/machine-learning/ml-sample-metadata';
import { MidFilter } from 'app/model/mid-filter';

import { RestfulApiService } from '../restful-api.service';

interface MLSampleRequest {
    name: string;
    bucketCount: number;
    bucketSize: number;
    correction: boolean;
    storeId?: number;
    storeField?: boolean;
    filters: MidFilter[];
    cobrander?: string;
}

class MLSampleService extends RestfulApiService<MlSampleMetadata> {
    public createSample(data: MLSampleRequest): Observable<MlSampleMetadata> {
        const searchParams: PatternData = {
            ...makePatternData(),
            cobrander: data.cobrander ?? '',
            matchOperator: MatchType.REGEX,
            locationOperator: LocationMatchType.REGEX,
            midPattern: '',
            descPattern: '',
            mccMatchOperator: MccMatchEnum.IN,
            mccPattern: [],
            cityPattern: '',
            statePattern: '',
            zipPattern: '',
            countryPattern: '',
            subChannel: undefined,
            extractField: '',
            extractPattern: '',
        };

        return this.http.post<MlSampleMetadata>(this.getAbsolutePath('ml/samples'), {
            samples: {
                type: 'str',
                searchParams,
                correction: data.correction ? '1' : '0',
                opposingId: undefined,
                storeId: data.storeId,
                searchAfter: [],
                filters: data.filters,
                name: data.name,
                bucketCount: data.bucketCount,
                bucketSize: data.bucketSize,
            },
        });
    }

    public putAction(sample: MlSampleMetadata): Observable<MlSampleMetadata> {
        return this.http.put<MlSampleMetadata>(this.getAlterUrl(`${sample.id}`), {
            sample_metadata: {
                name: sample.name,
            },
        });
    }

    /**
     * Merge samples.
     *
     * @param targetSampleId
     * @param sampleIds
     */
    public mergeSamples(targetSampleId: number, sampleIds: number[]): Observable<MlSampleMetadata> {
        return this.http.put<MlSampleMetadata>(this.getAlterUrl(`${targetSampleId}/merge`), {
            sample_merge: { sampleIds },
        });
    }

    protected getFormName(): string {
        return 'sample_metadata';
    }

    protected getPath(): string {
        return 'ml/samples';
    }
}

export const mlSampleService = new MLSampleService();
